import { useNavigate } from 'react-router-dom';

import { PanelNugget } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { LubavCompetency } from '@backrs_ui/grow-ui/src/models/models';

type CompetencyFormatterProps = Readonly<{
  competency: LubavCompetency;
}>;

export const CompetencyNugget = ({ competency }: CompetencyFormatterProps) => {
  const navigate = useNavigate();

  const handleClick = (id: string) => {
    navigate(`${APP_ROUTE.COMPETENCY}/${id}`);
  };

  return (
    <PanelNugget
      key={competency.id}
      title={competency.metadata.title}
      body={competency.metadata.description}
      subText={competency.relevance}
      size="SMALL"
      variant={{
        type: 'competency',
      }}
      onClick={() => {
        handleClick(competency.id);
      }}
    />
  );
};
